<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.707 2.293a1 1 0 0 0-1.069-.225l-18 7a1 1 0 0 0-.145 1.787l6.638 3.32 3.32 6.638a1 1 0 0 0 1.787-.145l7-18a1 1 0 0 0-.231-1.075z"/>
</svg>

